import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import CommentOutlineIcon from '@wix/da-ds/pkg/Icons/24x24/CommentOutline';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import { getDeviationResourceType } from '../../../../_helpers';
import noop from '../../../../../utils/noop';
import { useSubscriptionTier } from '../../../../../utils/hooks/useSubscriptionTier';
import { useDeviationAttributes } from '../../../../hooks/useDeviationAttributes';
import SubscribeToUnlockTooltip from '../../../../../ActionBar/_partials/SubscribeToUnlockTooltip';
var CommentControl = function (_a) {
    var _b, _c;
    var deviation = _a.deviation, className = _a.className, iconClassName = _a.iconClassName, textClassName = _a.textClassName, disabledClassName = _a.disabledClassName, _d = _a.onClick, onClick = _d === void 0 ? noop : _d;
    var t = useTranslation().t;
    var _e = useSubscriptionTier(deviation), isOwner = _e.isOwner, needsSubscription = _e.needsSubscription, isSubscribedButBlocked = _e.isSubscribedButBlocked;
    var isCommentable = useDeviationAttributes(deviation, isOwner).isCommentable;
    if (!isCommentable) {
        return null;
    }
    var actionBlockedBySubscription = needsSubscription || isSubscribedButBlocked;
    return (React.createElement(SubscribeToUnlockTooltip, { deviation: deviation },
        React.createElement(TextButton, { className: classnames(actionBlockedBySubscription && disabledClassName, className), size: "medium", variant: "main", "aria-label": t('deviationview.overlay.a11y.comment'), onClick: actionBlockedBySubscription ? undefined : onClick, disabled: actionBlockedBySubscription, biData: BiData({
                evid: 105,
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
                creatorid: (_c = (_b = deviation.author) === null || _b === void 0 ? void 0 : _b.useridUuid) !== null && _c !== void 0 ? _c : '',
                sectionname: BiContextProvidedValue,
                sectionid: BiContextProvidedValue,
                section_typeid: BiContextProvidedValue,
                sectiontype: BiContextProvidedValue,
                sectionrank: BiContextProvidedValue,
                rank: BiContextProvidedValue,
                sort_type: BiContextProvidedValue,
                reason_shown: BiContextProvidedValue,
                widgetname: BiContextProvidedValue,
            }) },
            React.createElement(CommentOutlineIcon, { className: iconClassName, size: IconSize.MEDIUM, disableDefaultColors: true }),
            React.createElement("span", { className: textClassName }, t('actionbar.comment')))));
};
CommentControl.displayName = 'CommentControl';
export default CommentControl;
//# sourceMappingURL=CommentControl.js.map